import React from "react";
import logo from "../assets/logo.webp";

export const LogoIcon = ({ className }) => (
  <img
    src={logo}
    alt="Subidha Inc."
    className={className}
    style={{ display: "block" }}
  />
);
